import { Fragment, type ReactNode } from "react";

/**
 * Renderiza texto simples com marcação **negrito** em <strong>.
 * Usado para destacar pontos-chave de conversão no conteúdo.
 */
export function rich(text: string): ReactNode {
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <strong key={`b-${i}`}>{part}</strong>
    ) : (
      <Fragment key={`t-${i}`}>{part}</Fragment>
    ),
  );
}

export function RichText({ children }: { children: string }) {
  return <>{rich(children)}</>;
}

export const plain = (text: string) => text.replace(/\*\*/g, "");
